import React from 'react'

const ProfileIcon = () => {
    return (
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.48128 6.17279C7.1069 6.17279 8.42545 4.78842 8.42545 3.08166C8.42545 1.37489 7.1069 0 5.48128 0C3.85566 0 2.53711 1.38437 2.53711 3.08166C2.53711 4.77894 3.85566 6.17279 5.48128 6.17279ZM5.48128 0.805971C6.6734 0.805971 7.64877 1.83003 7.64877 3.08166C7.64877 4.33328 6.6734 5.35734 5.48128 5.35734C4.28916 5.35734 3.31379 4.33328 3.31379 3.08166C3.31379 1.83003 4.28916 0.805971 5.48128 0.805971Z" fill="black" />
            <path d="M0.388342 11.0046H10.6117C10.8284 11.0046 11 10.8245 11 10.5969C11 8.46344 9.34729 6.71875 7.30624 6.71875H3.69376C1.66174 6.71875 0 8.45396 0 10.5969C0 10.8245 0.171593 11.0046 0.388342 11.0046ZM3.69376 7.5342H7.30624C8.78736 7.5342 10.0066 8.69101 10.1962 10.1892H0.803777C0.993432 8.70049 2.21264 7.5342 3.69376 7.5342Z" fill="black" />
        </svg>

    )
}

export default ProfileIcon